import { MarkExtension } from '../../../core/index.js';
import 'prosemirror-inputrules';
import { PluginKey } from 'prosemirror-state';
import 'prosemirror-model';
import 'prosemirror-commands';

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};
var isInNodeType = function(nodeType) {
    return function(selection) {
        var predicate = function(node) {
            return node.type === nodeType;
        };
        return !!findParentNode(predicate)(selection);
    };
};
/**
 * 判断选区中是否存在可以应用markType的节点
 * @param doc doc文档
 * @param ranges 选区
 * @param type markType类型
 */ var isExistAllowsMarkType = function(doc, ranges, type) {
    var _loop = function(i) {
        var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function(node) {
            if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
            return !can;
        });
        if (can) return {
            v: true
        };
    };
    for(var i = 0; i < ranges.length; i++){
        var _ret = _loop(i);
        if (_typeof(_ret) === "object") return _ret.v;
    }
    return false;
};
/**
 * 添加新的mark类型
 * @param type mark类型
 * @param attrs mark属性
 * @param enhance
 */ var addMarkType = function(type, attrs, enhance) {
    return function(state, dispatch) {
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, ranges = _state_selection.ranges;
        if (empty && !$cursor || !isExistAllowsMarkType(state.doc, ranges, type)) {
            return false;
        }
        // 是否为空光标
        if ($cursor) {
            // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
            var tr = state.tr;
            tr.addStoredMark(type.create(attrs));
            if (enhance) {
                tr = enhance(tr);
            }
            dispatch(tr);
        } else {
            var has = false;
            var tr1 = state.tr;
            for(var i = 0; !has && i < ranges.length; i++){
                var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
                has = state.doc.rangeHasMark($from.pos, $to.pos, type);
            }
            for(var i1 = 0; i1 < ranges.length; i1++){
                var _ranges_i1 = ranges[i1], $from1 = _ranges_i1.$from, $to1 = _ranges_i1.$to;
                // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
                if (has) tr1.removeMark($from1.pos, $to1.pos, type);
                tr1.addMark($from1.pos, $to1.pos, type.create(attrs));
            }
            dispatch(tr1);
        }
        return true;
    };
};

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
/**
 * 判断选区内容是否支持指定类型的 mark 节点
 */ function markApplies(doc, ranges, type) {
    var _loop = function(i) {
        var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function(node) {
            if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
            return !can;
        });
        if (can) return {
            v: true
        };
    };
    for(var i = 0; i < ranges.length; i++){
        var _ret = _loop(i);
        if (_typeof$1(_ret) === "object") return _ret.v;
    }
    return false;
}

/**
 * 恢复当前选区的文字颜色
 */ var setDefaultFontColor = function() {
    return function(state, dispatch, view) {
        var colorType = state.schema.marks.color;
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, ranges = _state_selection.ranges;
        if (empty && !$cursor || !markApplies(state.doc, ranges, colorType)) {
            return false;
        }
        if ($cursor) {
            dispatch(state.tr.removeStoredMark(colorType));
        } else {
            var tr = state.tr;
            for(var i = 0; i < ranges.length; i++){
                var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
                tr.removeMark($from.pos, $to.pos, colorType);
            }
            dispatch(tr.scrollIntoView());
        }
        view.focus();
        return true;
    };
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ColorExtension = /*#__PURE__*/ function(MarkExtension) {
    _inherits(ColorExtension, MarkExtension);
    var _super = _createSuper(ColorExtension);
    function ColorExtension() {
        _classCallCheck(this, ColorExtension);
        return _super.apply(this, arguments);
    }
    var _proto = ColorExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            setColor: function(color) {
                if (!color) return setDefaultFontColor();
                return addMarkType(type, {
                    color: color
                });
            },
            setDefaultColor: setDefaultFontColor,
            isDisabled: function() {
                return function(param) {
                    var selection = param.selection, schema = param.schema;
                    return isInNodeType(schema.nodes.code_block)(selection);
                };
            }
        };
    };
    _createClass(ColorExtension, [
        {
            key: "name",
            get: function get() {
                return "color";
            }
        }
    ]);
    return ColorExtension;
}(MarkExtension);

export { ColorExtension };
//# sourceMappingURL=index.js.map
